<template>
  <v-container>
    <div v-if="!loading">
      <div class="d-flex flex-nowrap container" v-if="recentFeedbacks && recentFeedbacks.length">
        <v-card outlined v-for="messageGroup in recentFeedbacks" :key="messageGroup.id" class="mr-4 elevation-0">
          <v-card-title class="title"
            ><div>
              <div class="text-subtitle-1">
                Phụ huynh em {{ messageGroup.student && messageGroup.student.name }} <v-icon>mdi-menu-right</v-icon>
                {{ messageGroup.name }}
              </div>
              <p class="text-body-2" v-if="messageGroup.lastParentMessage">
                {{ messageGroup.lastParentMessage.createdAt | ddmmyyyyhhmm }}
              </p>
            </div>
          </v-card-title>
          <v-card-text>
            <div class="mr-4" v-if="messageGroup.lastParentMessage && messageGroup.lastParentMessage.content">
              <MaxLengthText :text="messageGroup.lastParentMessage.content" />
            </div>
            <div class="mr-4" v-if="messageGroup.lastParentMessage && messageGroup.lastParentMessage.image">
              Đã gửi 1 ảnh
            </div>
            <div class="mt-2 d-flex justify-space-between">
              <v-chip small label :color="messageGroup.isReply ? 'green' : '#F4BB43'" dark>
                <span>
                  {{ messageGroup.isReply ? 'Đã trả lời' : 'Chưa trả lời' }}
                </span>
              </v-chip>
              <div>
                <router-link
                  style="text-decoration: none"
                  :to="(messageGroup.type === 'manager' ? '/feedback/' : '/teacher-feedback/') + messageGroup.id"
                >
                  <div style="white-space: nowrap">Xem chi tiết</div>
                </router-link>
              </div>
            </div>
          </v-card-text>
        </v-card>
      </div>
      <div v-else>Chưa có phản hồi từ phụ huynh</div>
    </div>
    <div v-else>
      <v-skeleton-loader type="card-avatar, actions"></v-skeleton-loader>
    </div>
  </v-container>
</template>
<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import MaxLengthText from '@/components/basic/read-more/MaxLengthText.vue'

export default {
  components: { MaxLengthText },
  data: () => ({ loading: false }),
  async created() {
    this.loading = true
    const messageGroupParams = { _sort: 'updatedAt:DESC' }
    if (this.role.type === 'teacher') {
      messageGroupParams.type = 'teacher'
      messageGroupParams['class_in'] = this.profile.ownClasses.map(c => c.id)
    } else {
      messageGroupParams.type = 'manager'
    }

    await this.fetchFeedback(messageGroupParams)
    this.loading = false
  },
  computed: { ...mapState('Dashboard', ['recentFeedbacks']), ...mapGetters('auth', ['profile', 'role']) },
  methods: { ...mapActions('Dashboard', ['fetchFeedback']) },
}
</script>
<style scoped lang="scss">
.title {
  min-width: 300px;
}
.container {
  overflow-x: auto;
  max-width: 100%;
}
.container::-webkit-scrollbar {
  -webkit-appearance: none;
}
.container::-webkit-scrollbar:horizontal {
  height: 10px;
}
.container::-webkit-scrollbar-thumb {
  border-radius: 8px;
  border: 2px solid white;
  background-color: rgba(0, 0, 0, 0.5);
}
</style>
